<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Tipe Produk Layanan'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'payment-category-types'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/payment-category-types/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: '',
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Tipe Produk Layanan", route: "" },
      { title: "Daftar Tipe Produk Layanan", route: "/masters/payment-category-types/list" },
      { title: "Tambah" },
    ])
  },

}

</script>